<div class="modal-overlay">
<div class="modal-header" style="height: 40px;display: flex;flex-direction: row;justify-content: space-between;align-self: center;align-items: center">
    <h6 class="mt-2 text-uppercase text-dark fw-bolder">Select Your Payment Option</h6>
    <svg (click)="closeModal()" style="cursor: pointer" width="15" height="15" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.55078 21.061L11.178 11.4338M20.8051 1.80664L11.1761 11.4338M11.1761 11.4338L1.55078 1.80664M11.178 11.4338L20.8051 21.061" stroke="#F00000" stroke-width="2.77707" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</div>
<div class="container modal-body bg-white p-4">

    <div class="paymentCont">
        <div class="paymentWrap">
            <div class="btn-group paymentBtnGroup d-flex justify-content-center" data-toggle="buttons">

                <label class="btn paymentMethod" style="width: 100px;">
                    <button (click)="interswitchStart()" id="interswitch">
                        <img src="/assets/img/interswitch2.png" style="width: 130px;">
                    </button>
                </label>

                <label class="btn paymentMethod" style="width: 100px;">
                    <div class="method remitta"></div>
                    <input (click)="startRemita()" [disabled]="generating"
                           type="radio" [(ngModel)]="paymentType"
                           value="remita" name="options" />
                </label>


            </div>

        </div>
    </div>
</div>
</div>

<app-app-loader></app-app-loader>
